var map = {
	"./arrow-btn.svg": [
		3263,
		3263
	],
	"./back.svg": [
		1614,
		1614
	],
	"./close.svg": [
		2307,
		2307
	],
	"./exit.svg": [
		6727,
		9108
	],
	"./footer-btn-icon.svg": [
		6987,
		6987
	],
	"./footer-logo.svg": [
		124,
		124
	],
	"./games/1224.svg": [
		5124,
		5124
	],
	"./games/4x20.svg": [
		7489,
		7489
	],
	"./games/5x2.svg": [
		3772,
		3772
	],
	"./games/5x36plus.svg": [
		6255,
		6255
	],
	"./games/6x36.svg": [
		8958,
		8958
	],
	"./games/6x45.svg": [
		4884,
		4884
	],
	"./games/7x49.svg": [
		1395,
		1395
	],
	"./games/bingo75.svg": [
		3782,
		3782
	],
	"./games/duel.svg": [
		1545,
		1545
	],
	"./games/express.svg": [
		7379,
		7379
	],
	"./games/gzhl.svg": [
		1328,
		1328
	],
	"./games/joker.svg": [
		1826,
		1826
	],
	"./games/keno.svg": [
		3014,
		3014
	],
	"./games/keno2.svg": [
		7326,
		7326
	],
	"./games/rapido.svg": [
		7766,
		7766
	],
	"./games/rapido2.svg": [
		3470,
		3470
	],
	"./games/rocketbingo.svg": [
		3706,
		3706
	],
	"./games/ruslotto.svg": [
		1667,
		1667
	],
	"./games/spec.svg": [
		9594,
		3565
	],
	"./games/top2.svg": [
		7050,
		7050
	],
	"./games/zodiac.svg": [
		8807,
		8807
	],
	"./games/zp.svg": [
		357,
		357
	],
	"./header-logo.svg": [
		7213,
		9594
	],
	"./like.svg": [
		9702,
		9702
	],
	"./link.svg": [
		4871,
		4871
	],
	"./loading.svg": [
		8859,
		8859
	],
	"./media-logo.svg": [
		8607,
		8607
	],
	"./narrative-close.svg": [
		9578,
		9578
	],
	"./nav-next.svg": [
		3404,
		3404
	],
	"./nav-prev.svg": [
		2580,
		2580
	],
	"./news/back.svg": [
		5034,
		5034
	],
	"./news/comments.svg": [
		5509,
		5509
	],
	"./news/likes.svg": [
		8327,
		8327
	],
	"./news/soc/ok.svg": [
		8729,
		8729
	],
	"./news/soc/rt.svg": [
		9297,
		9297
	],
	"./news/soc/tg.svg": [
		9020,
		9020
	],
	"./news/soc/vk.svg": [
		5674,
		5674
	],
	"./news/time.svg": [
		3548,
		3548
	],
	"./news/up.svg": [
		2640,
		2640
	],
	"./news/views.svg": [
		1521,
		1521
	],
	"./next-narrative.svg": [
		7433,
		7433
	],
	"./next.svg": [
		6604,
		6604
	],
	"./podcast/gp-color.svg": [
		3679,
		3679
	],
	"./podcast/gp.svg": [
		7809,
		7809
	],
	"./podcast/ip-color.svg": [
		3213,
		3213
	],
	"./podcast/ip.svg": [
		8655,
		8655
	],
	"./podcast/vk-color.svg": [
		4535,
		4535
	],
	"./podcast/vk.svg": [
		4985,
		4985
	],
	"./podcast/ym-color.svg": [
		3664,
		3664
	],
	"./podcast/ym.svg": [
		2430,
		2430
	],
	"./prev-narrative.svg": [
		5617,
		5617
	],
	"./prev.svg": [
		5511,
		7892
	],
	"./projects/arrow.svg": [
		1139,
		1139
	],
	"./projects/google.svg": [
		755,
		755
	],
	"./projects/ios.svg": [
		7971,
		7971
	],
	"./projects/vk.svg": [
		643,
		643
	],
	"./projects/ya.svg": [
		932,
		932
	],
	"./search.svg": [
		5783,
		5783
	],
	"./send-sqr.svg": [
		2588,
		2588
	],
	"./send.svg": [
		5917,
		5917
	],
	"./share/ok.svg": [
		9193,
		9193
	],
	"./share/tg.svg": [
		8828,
		8828
	],
	"./share/vk.svg": [
		1050,
		1050
	],
	"./social/ok.svg": [
		5225,
		5225
	],
	"./social/rt.svg": [
		8673,
		8673
	],
	"./social/tg.svg": [
		2876,
		2876
	],
	"./social/vk.svg": [
		8762,
		8762
	],
	"./stoloto-logo.svg": [
		7371,
		7371
	],
	"./time.svg": [
		4072,
		4072
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1444;
module.exports = webpackAsyncContext;